import React from "react"
import Tabs from '../Tabs/Tabs'
import ProductPresenterWorkspace from "./ProductPresenterWorkspace"

class ProductPresenter extends React.Component {

  constructor(props) {
    super(props);
      this.state ={
        activeTab: 'general',
        ...this.props
      };
      this.onChangeTab = this.onChangeTab.bind(this);
      this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
  };

  componentDidMount() {
    var self = this
    $(window).on("productSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/products/${self.props.product.id}/data`,
      }).done((data) => {
        self.setState({...data});
      })
    });
  }

  render() {
    var self = this
    return(
      <div className="panel panel-form">
        <Tabs tabs={this.Tabs()} />

        <div className="tab-content">
          <ProductPresenterWorkspace
            {...this.state}
            activeTab={this.state.activeTab}
          />
        </div>
      </div>
    );
  };

  onChangeTab(name) {
    this.setState({
      activeTab: name,
    });
  };

  onChangeRevertVersion() {
    var self = this
    $.ajax({
      type: 'POST',
      url: `/admin/products/${this.props.product.id}/version/${this.props.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger('productSaved');
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      };
    });
  };

  Tabs() {
    return (
      !this.props.historical_view
      ?
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.activeTab === 'general' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          {
            tabName: I18n.t('room_types'),
            targetName: 'room_types',
            classes: this.state.activeTab === 'room_types' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          {
            tabName: I18n.t('images'),
            targetName: 'images',
            classes: this.state.activeTab === 'images' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          {
            tabName: I18n.t('taxes_and_fees'),
            targetName: 'taxes',
            classes: this.state.activeTab === 'taxes' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          {
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.activeTab === 'history' ? 'active' : null,
            changeHandler: this.onChangeTab,
          }
        ]
      :
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.activeTab === 'general' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          // {
          //   tabName: I18n.t('images'),
          //   targetName: 'images',
          //   classes: this.state.activeTab === 'images' ? 'active' : null,
          //   changeHandler: this.onChangeTab,
          // },
        ]

    );

  };

};

export default ProductPresenter
